var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 33.007C16.663 34.164 17.833 34.866 19.237 34.866C20.888 34.866 22.11 33.878 22.11 32.383C22.11 31.252 21.447 30.576 20.056 29.939L19.094 29.497C18.249 29.068 17.95 28.951 17.898 28.275C17.898 27.599 18.47 27.235 19.198 27.235C19.926 27.235 20.55 27.599 21.005 28.275L21.967 27.534C21.434 26.611 20.407 26 19.198 26C17.716 26 16.494 26.923 16.494 28.327C16.494 29.471 17.248 30.134 18.496 30.706L19.445 31.148C20.342 31.564 20.706 31.824 20.706 32.435C20.706 33.163 20.108 33.631 19.224 33.631C18.236 33.631 17.547 33.098 16.975 32.266L16 33.007Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5682 34.723H31.0502L27.2672 26H26.7992L23.0162 34.723H24.4852L25.0962 33.293H28.9572L29.5682 34.723ZM28.4632 32.11H25.5902L27.0332 28.561L28.4632 32.11Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4167 34.723H37.7207V33.488H33.7947V26.143H32.4167V34.723Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1071 34.723H44.9051V33.488H40.4851V30.771H43.6961V29.575H40.4851V27.378H44.7491V26.143H39.1071V34.723Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale);
export default __webpack_public_path__ + "static/media/sale.7db2ccaacb70c31f790b6a071bf0e8b5.svg";
export { ForwardRef as ReactComponent };